import { fetchArray } from "entity";
import { useEffect, useState } from "react"
import Reuniao from ".";
// import Rodada from 'entity/Rodada'

export function useAllAtiveReunioes(rodada, mesa, refReunioes) {
    const [reunioes, setReunioes] = useState()
    useEffect(() => {
        async function busca() {
            let query = await Reuniao.query();

            query = query.where("rodada.uid", "==", rodada.uid)
            query = query.where("status", "==", "ATIVO")
            if (mesa) {
                query = query.where("mesa.uid", "==", mesa.uid)
            }

            const result = await fetchArray(query.get());
            setReunioes(result);
        }
        if (rodada && !refReunioes) {
            busca()
        } else {

            if (mesa) {

                let filte = refReunioes.filter(r => r.mesa && r.mesa.uid === mesa.uid)

                setReunioes(filte);
            } else {

                setReunioes([]);
            }
        }
        return () => {
            setReunioes(null)
        }
    }, [rodada, mesa, refReunioes])

    return reunioes
}
export function useAllReunioes(rodada, mesa) {
    const [reunioes, setReunioes] = useState(null)
    useEffect(() => {
        async function busca() {
            let query = await Reuniao.query();

            query = query.where("rodada.uid", "==", rodada.uid)
            if (mesa) {
                query = query.where("mesa.uid", "==", mesa.uid)
            }

            const result = await fetchArray(query.get());
            setReunioes(result);
        }
        if (rodada) {
            busca()
        }
        return () => {
            setReunioes(null)
        }
    }, [rodada, mesa])

    return reunioes
}

export function useAllAtiveReunioesByInscricao(rodada, inscricao) {


    const [reunioes, setReunioes] = useState()
    useEffect(() => {
        if (rodada && inscricao) {
            return Reuniao.query().then((query) => {
                query = query.where("rodada.uid", "==", rodada.uid)
                query = query.where("status", "==", "ATIVO")
                query = query.where("inscricoesQuery." + inscricao.uid, "==", true)
                query.onSnapshot((qs) => {
                    let l = [];
                    if (!qs.empty) {
                        qs.forEach((doc) => {
                            let newV = doc.data();

                            l.push(newV);

                        });
                    }
                    // const result = fetchArray(querySnapshot);
                    l.sort((a, b) => {
                        if (a.horario && b.horario) {
                            return a.horario.horario.localeCompare(b.horario.horario)
                        }
                        return 0;
                    })
                    setReunioes(l)

                })
            })
        }

    }, [rodada, inscricao])

    return [reunioes]




}

export async function getReunioes(uidInscricao) {

    let query = await Reuniao.query()
    query = query.where("inscricao1.uid", '==', uidInscricao)
        .where("status", "==", "ATIVO")
    const result = await fetchArray(query.get());
    let q2 = await Reuniao.query()
    q2 = q2.where("inscricao2.uid", '==', uidInscricao)
        .where("status", "==", "ATIVO")
    const r2 = await fetchArray(q2.get());
    return result.concat(r2)
}
export async function getReuniaoEntre(uidInscricao1, uidInscricao2) {

    let query = await Reuniao.query()
    query = query.where("inscricao1.uid", '==', uidInscricao1)
        .where("inscricao2.uid", '==', uidInscricao2)
        .where("status", "==", "ATIVO")

    const result = await fetchArray(query.get());
    let q2 = await Reuniao.query()
    q2 = q2.where("inscricao1.uid", '==', uidInscricao2)
        .where("inscricao2.uid", '==', uidInscricao1)
        .where("status", "==", "ATIVO")
    const r2 = await fetchArray(q2.get());


    return result.concat(r2)
}

export async function getReuniaoNoHorario(uidInscricao1, uidInscricao2, horario) {



    let q3 = await Reuniao.query()
    q3 = q3.where("inscricao1.uid", 'in', [uidInscricao1, uidInscricao2])
        .where("status", "==", "ATIVO")
        .where("horario.horario", "==", horario)

    const r3 = await fetchArray(q3.get());

    let q4 = await Reuniao.query()
    q4 = q4.where("inscricao2.uid", 'in', [uidInscricao1, uidInscricao2])
        .where("status", "==", "ATIVO")
        .where("horario.horario", "==", horario)

    const r4 = await fetchArray(q4.get());

    return r3.concat(r4)
}